import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import { YourInfoPage as HOYourInfoPage, QuotePage as HOQuotePage } from 'gw-capability-quoteandbind-common-react';
import { QualificationPage, ConstructionPage, AdditionalDiscountsPage } from 'ml-capability-quoteandbind-common-react';

import HOYourHomePage from './pages/YourHome/YourHomePage';
import HOAdditionalInformation from './pages/AdditionalInformation/AdditionalInformationPage';
import HOPolicyInformationPage from './pages/PolicyInformation/PolicyInformationPage';
import HOSuccessPage from './pages/Success/SuccessPage';
import HOAdditionalInfoToQuotePage from './pages/HOAdditionalInfoToQuote/HOAdditionalInfoToQuote';
import HOProductSelectionPage from './pages/HOProductSelection/HOProductSelectionPage';
import HOAdditionalInformationPreBindPage from './pages/HOAdditionalInformationPreBind/HOAdditionalInformationPreBindPage';


setComponentMapOverrides(
    {
        HOYourInfoPage: { component: 'HOYourInfoPage' },
        HOQualificationPage: { component: 'HOQualificationPage' },
        HOYourHomePage: { component: 'HOYourHomePage' },
        HOConstructionPage: { component: 'HOConstructionPage' },
        HOAdditionalDiscountsPage: { component: 'HOAdditionalDiscountsPage' },
        HOQuotePage: { component: 'HOQuotePage' },
        HOAdditionalInformation: { component: 'HOAdditionalInformation' },
        HOPolicyInformationPage: { component: 'HOPolicyInformationPage' },
        HOSuccessPage: { component: 'HOSuccessPage' },
        HOAdditionalInfoToQuotePage: { component: 'HOAdditionalInfoToQuotePage' },
        HOProductSelectionPage: { component: 'HOProductSelectionPage' },
        HOAdditionalInformationPreBindPage: { component: 'HOAdditionalInformationPreBindPage' }
    },
    {
        HOYourInfoPage,
        HOQualificationPage: QualificationPage,
        HOYourHomePage,
        HOConstructionPage: ConstructionPage,
        HOAdditionalDiscountsPage: AdditionalDiscountsPage,
        HOQuotePage,
        HOAdditionalInformation,
        HOPolicyInformationPage,
        HOSuccessPage,
        HOAdditionalInfoToQuotePage,
        HOProductSelectionPage,
        HOAdditionalInformationPreBindPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as HOWizard } from './HOWizard';
export { default as HOPolicySummaryComponent } from './components/HOPolicySummaryComponent/HOPolicySummaryComponent'
